import { toLines } from '../../../../common/utils'

const locationTypeSimpleDetailsFormInitialValues = ({
  description,
  synonyms,
  position,
  isExcludedFromSearch,
  isExcludedFromBrowsing,
}) => ({
  description,
  synonyms: toLines(synonyms),
  position,
  isExcludedFromSearch,
  isExcludedFromBrowsing,
})

export default locationTypeSimpleDetailsFormInitialValues
